<!-- <script setup lang="ts">
import Slidebar from './components/Slidebar.vue';

</script> -->

<template>
  <!-- <Slidebar/> -->
  <!-- <div id="app"> -->
    <router-view/>
    <notifications position="top right" width="20%"/>
  <!-- </div> -->
</template>
<!-- 
<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
</style> -->
